import React from 'react';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import NoContentPage from '@features/components/no-content-page';
import { ModuleLandingPage } from '@/containers/module-landing/module-landing-page';
import { WebinarModuleLandingPage } from '@/containers/module-landing/webinar-module-landing-page';
import ErrorPage from '@features/components/error-page';
import { useModuleLanding } from '@/containers/module-landing/index.ViewHook';
import { LoadingSkeleton } from '@/containers/module-landing/loading-skeleton';
import { REGION_CONFIG } from '@/region-config';
import { useFeelgood } from '@/libs/useFeelgood';
import { TriggerKey } from '@/constants';

export const ModuleLandingPageWrapper = () => {
  const { t } = useTranslation();
  const { loading, err, errorText, empty, hotModuleData, exploreData } =
    useModuleLanding();
  useFeelgood(TriggerKey.Module);

  return (
    <>
      {loading ? (
        <LoadingSkeleton />
      ) : err ? (
        <div className="h-[70vh] py-16 flex flex-1 justify-center items-center rounded-8">
          <ErrorPage
            hasNewVersion={true}
            title={t(errorText.title)}
            text={t(errorText.text)}
            leftButton={{
              type: 'primary',
              text: t(errorText.buttonText),
              onClick: errorText.buttonClick,
            }}
          />
        </div>
      ) : empty ? (
        <div className="h-[70vh] py-16 flex flex-1 justify-center items-center rounded-8">
          <NoContentPage />
        </div>
      ) : REGION_CONFIG.activeWebinarModule ? (
        <WebinarModuleLandingPage moduleData={exploreData} />
      ) : (
        <ModuleLandingPage
          exploreData={exploreData}
          hotModuleData={hotModuleData}
        />
      )}
    </>
  );
};
